import { useQuery } from '@tanstack/react-query';
import { provinceApi } from '../../../services';
import { ChoroplethDataSchema } from '../../../schemas/chartSchema';
import {
	createStatsQueryHook,
	createChartQueryHook,
	type StatsQueryParams,
	type ChartQueryParams,
} from '../../../hooks';

export type UseProvincesQueryParams = StatsQueryParams;
export type UseProvincesChartParams = ChartQueryParams;

const PROVINCE_FILTER_KEYS = ['query', 'years', 'maKhoa', 'maNganh', 'maTinh'] as const;

export const useProvincesQuery = createStatsQueryHook({
	entityKey: 'provinces',
	apiFn: (params) => provinceApi.getProvinceStats(params),
	filterKeys: PROVINCE_FILTER_KEYS,
});

export const useProvincesChartQuery = createChartQueryHook({
	entityKey: 'provinces',
	apiFn: (params) => provinceApi.getNivoLineChartData(params),
	filterKeys: PROVINCE_FILTER_KEYS,
});

interface UseProvincesChoroplethParams {
	selectedYear: number | null;
	selectedFaculty?: string | null;
}

export const useProvincesChoroplethQuery = (params: UseProvincesChoroplethParams) => {
	return useQuery({
		queryKey: ['provinces', 'choropleth', params.selectedYear, params.selectedFaculty],
		queryFn: async () => {
			const searchParams = new URLSearchParams();
			if (params.selectedYear !== null) {
				searchParams.append('years', params.selectedYear.toString());
			}
			if (params.selectedFaculty) {
				searchParams.append('maKhoa', params.selectedFaculty);
			}
			const response = await provinceApi.getProvinceChoroplethData(searchParams);
			return ChoroplethDataSchema.parse(response.data);
		},
		enabled: true,
		retry: 1,
		refetchOnWindowFocus: false,
	});
};